import React from "react";
import ModalHeaderTitle from "../atom/ModalHeaderTitle";


const PopupHeader = ({ title, callback }) => {

  return (
    <div className={"detail-design-history-header"}>
      <div className={"detail-design-history-inner"}>
        <ModalHeaderTitle title={title}/>
        <button type="button"
                className="modal-close"
                onClick={callback}
        />
      </div>
    </div>

  )
}

export default PopupHeader;
